import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldAppearance, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FieldBase, FieldOption } from '@nagel-types';
import { IconComponent } from '@nagel-assests';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
    selector: 'lib-lookup-field',
    providers: [],
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatInputModule,
        IconComponent,
        MatProgressSpinnerModule
    ],
    templateUrl: './lookup-field.component.html',
    styleUrl: './lookup-field.component.scss'
})
export class LookupFieldComponent extends BaseFieldComponent implements OnInit {
  @Input() override field!: FieldBase<unknown>;
  @Input() override form?: FormGroup;
  @Input() appearance: MatFormFieldAppearance = 'outline';

  @Input() errorStateMatcher: ErrorStateMatcher = new ErrorStateMatcher();
  @Input() key: string = '';
  @Input() icon: string = '';
  @Input() value: string = '';
  @Input() className: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() changeHandler?: (event: MatSelectChange) => void;
  @Input() options: FieldOption[] = [];
  @Input() warningText = '';

  @Output() changeSelection = new EventEmitter<unknown>();

  isLoading = false;
  internalOptions: FieldOption[] = [];

  ngOnInit() {
      if (this.field) {

          this.key = this.field.key;
          this.icon = this.field.icon;
          this.className = this.field.className;
          this.label = this.field.label;
          this.placeholder = this.field.placeholder;
          this.changeHandler = this.field.onChange;
          this.options = this.field.options;
          this.value = this.field.value as string;
      }

      if (this.shouldUpdate()) {
          this.internalOptions = this.options;
      }
  }

  ngOnChanges() {
      if (this.shouldUpdate()) {
          this.internalOptions = this.options;
      }
  }

  onSelectChange(event: MatSelectChange) {
      if (this.changeHandler) {
          this.changeHandler(event);
      }

      this.changeSelection.emit(event);
  }

  onOpenSuccessHandler = (data: FieldOption[]) => {
      this.internalOptions = data;
      this.isLoading = false;
  };

  private shouldUpdate(): boolean {
      return (
          this.options
        && Array.isArray(this.options)
        && JSON.stringify(this.options) !== JSON.stringify(this.internalOptions)
      );
  }
}